<tyt-pricing-prompt-offers 
    [headLine]="offerSet.payment_prompt_subtitle"
    [caption]="offerSet.payment_prompt_details"></tyt-pricing-prompt-offers>
<div class="payment-container">
    <ng-container *ngIf="!submitting">

        <!-- PRICING SUMMARY -->
        <!-- START FIXED PRICING TRANSACTION SUMMARY -->
        
        <div class="offer-title">
            <ng-container *ngIf="!offerSet.is_pay_what_you_want">
                {{offer?.title || offer?.membership_product?.name}}
            </ng-container>
            <!-- 
                ** Removed by request by Greg
                ** | in this case, the [eg] $7.99 / month “headline” can be a bit misleading, 
                ** | since that isn’t going to be what’s billed after the introductory price. 
                ** | I’m not sure why we need the “headline” at all

                <ng-container *ngIf="offerSet.is_pay_what_you_want">
                {{applicablePrice / 100 | currency: 'USD'}}{{perApplicablePeriod}}
                </ng-container> 
            -->
        </div> 

        <div class="transaction-explanation">
            <ng-container *ngIf="period">
                <ng-container *ngIf="applicableTrialDays > 0">
                    Nothing will be charged during your 
                    {{applicableTrialDays}} day free trial. 
                    You will be charged 
                    {{applicablePriceUSD | currency: 'USD'}}{{perApplicablePeriod}}
                    when your trial expires.
                </ng-container>
                <ng-container *ngIf="!applicableTrialDays">
                    <ng-container *ngIf="applicableIntroductoryPeriods > 0">
                        You will be charged <span class="key-info">{{applicablePriceUSD | currency: 'USD'}}{{perApplicablePeriod}}</span>
                        for the first <span class="key-info">{{applicableIntroductoryPeriods}} 
                            {{applicablePeriodPlural(applicableIntroductoryPeriods)}}</span>
                        then your plan will renew at
                        <span class="key-info">{{applicableProductPriceUSD | currency: 'USD'}}{{perApplicablePeriod}}</span>
                    </ng-container>
                    <ng-container *ngIf="!applicableIntroductoryPeriods && period !== 'one_time'">
                        You will be charged <span class="key-info">{{applicablePriceUSD | currency: 'USD'}} now</span>
                        and your plan will <span class="key-info"> renew at 
                        {{applicablePriceUSD | currency: 'USD'}}{{perApplicablePeriod}}</span>
                    </ng-container>
                    <ng-container *ngIf="!applicableIntroductoryPeriods && period === 'one_time'">
                        You will be charged <span class="key-info">{{applicablePriceUSD | currency: 'USD'}} now</span>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>

        <!-- END PWYW TRANSACTION SUMMARY -->

        <div class="payment-method">
            <img class="invert-on-dark" src="/assets/offers/payment-black.png">
            <span>Payment Method</span>
            <div class="divisor-line"></div>
        </div>
        
        <div class="credit-card">
            <label>Credit / Debit Card</label>
            <div class="card-logos"><img src="/assets/offers/card-logos.png"></div>
        </div>
        <div class="credit-card-container">
            <div class="card-form-container">
                <app-form #form [handler]="this" (submit)="submit()">
                    <error-message [producer]="this"></error-message>

                    <div class="secure-label">
                        <img class="invert-on-dark" src="/assets/offers/lock-black.png">
                        <span>Secure Connection</span>
                    </div>
                    <ng-container *ngIf="paymentSource && !enterNewCard">
                        <div>
                            {{paymentSource.brand}} **{{paymentSource.last4}} ({{paymentSource.exp_month}}/{{paymentSource.exp_year}})
                        </div>
                        <a href="javascript:;" (click)="useNewCard()">
                            Use a different card
                        </a>
                    </ng-container>

                    <ng-container *ngIf="!paymentSource || enterNewCard">
                        <input 
                            type="text" 
                            name="cardholder-name" 
                            errorHighlight
                            [(ngModel)]="cardholderName" 
                            class="form-control" 
                            placeholder="Card Holder Name"
                            autocomplete="cc-name"
                            />

                        <input 
                            type="text" 
                            id="cardNumber" 
                            name="cc-number" 
                            errorHighlight
                            [(ngModel)]="cardNumber" 
                            class="form-control" 
                            placeholder="Card Number"
                            autocomplete="cc-number"
                            />
                        
                        <div class="second-line">
                            <input 
                                type="string" 
                                id="expiryDate" 
                                name="cc-exp" 
                                errorHighlight
                                [(ngModel)]="expiryDate" 
                                class="form-control exp"
                                autocomplete="cc-exp"
                                placeholder="Expiry (MM/YYYY)"
                                />
                            <input 
                                type="text" 
                                id="cvc" 
                                name="cc-csc" 
                                errorHighlight
                                [(ngModel)]="cvc" 
                                class="form-control cvc" 
                                placeholder="CVC"
                                autocomplete="cc-csc"
                                />
                            <input 
                                type="text" 
                                id="zip" 
                                name="cc-zipcode" 
                                errorHighlight
                                [(ngModel)]="zip" 
                                class="form-control zip" 
                                placeholder="Zip / Postal Code"
                                autocomplete="postal-code"
                                />
                        </div>
                        <ng-container *ngIf="paymentSource">
                            Or <a href="javascript:;" (click)="useExistingCard()">
                                Use saved card
                            </a>
                        </ng-container>
                    </ng-container>

                    <div>
                        <div class="terms">
                            <p class="second">
                                <ng-container *ngIf="recurring">
                                    Your membership will renew automatically. You can cancel at any time.

                                    <ng-container *ngIf="applicablePeriod === 'monthly'">
                                    Monthly plans renew each month on the same day of the month that you sign up.
                                    </ng-container>

                                    <ng-container *ngIf="applicablePeriod === 'annually'">
                                        Annual plans renew each year on the same day of the year that you sign up. 
                                    </ng-container>

                                    You can change your membership plan at any time. Plan changes are prorated,
                                    credit is issued for changes to less expensive plans.
                                </ng-container>
                                <ng-container *ngIf="!recurring">
                                    You are making a one-time contribution. We will not rebill you at a later time.
                                </ng-container>
                                By proceeding, you are agreeing to our <a href="/terms" target="_blank">Terms and Conditions.</a> 
                                To find out what personal data we collect and how we use it, please visit 
                                our <a href="/privacy" target="_blank">Privacy Policy.</a>
                            </p>
                        </div>

                        <div class="subscribe-caption">Let's Go {{user?.display_name}}!</div>

                        <ng-container *ngIf="error">
                            <br/><br/>
                            <div class="alert alert-danger">
                                Transaction was not successful. Please review the errors above before proceeding.
                            </div>
                        </ng-container>

                        <button class="subscribe-button">
                            <span class="first" *ngIf="period !== 'one_time' else contributeButton">Start Membership</span>
                            <ng-template #contributeButton>
                                <span class="first">Contribute Now</span>
                            </ng-template>
                        </button>
                    </div>
                </app-form>
            </div>
        </div>

        <div class="payment-method">
            <img class="invert-on-dark" src="/assets/offers/payment-black.png">
            <span>Or, choose another payment method</span>
            <div class="divisor-line"></div>
        </div>
        
        <div class="other-methods">
            <a 
                href="javascript:;" 
                class="apple-pay method" 
                [class.available]="applePayAvailable"
                (click)="!submitting && submitApplePay()"
                >
                <img src="/assets/offers/apple-pay.png">
                <em>Available in Safari on macOS and iOS devices after enrolling in Apple Pay</em>
            </a>
        </div>

    </ng-container>
    <ng-container *ngIf="submitting">
        <div class="loading">
            <app-spinner></app-spinner>
            <h1>Just a second...</h1>
        </div>
    </ng-container>
</div>